import { useNavigate } from 'react-router-dom';
import AddProductDialog from '../../AddProductDialog';
import { showToastError, showToastSuccess } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { addProduct } from '../../hooks/useProducts';

export default function AddProductContainer() {
  const navigate = useNavigate();
  const { org } = useLegacyAppSession();

  return (
    <AddProductDialog
      onClose={() => navigate('/products', { replace: true })}
      organizationId={org?.id ?? null}
      onSave={async (product) => {
        try {
          await addProduct(product);
          showToastSuccess('Product successfully added.');
          navigate('/products', { replace: true });
        } catch (error) {
          showToastError('Product could not be added');
          console.error(error);
        }
      }}
    />
  );
}
